






















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class CountDown extends Vue {
  public now = new Date().getTime();
  public end = this.$store.getters.activity.start;

  public items = ['days', 'hours', 'minutes', 'seconds'];

  get diff() {
    return this.end > this.now ? this.end - this.now : 0;
  }

  public getValue(item: string, count: number) {
    switch (item) {
      case 'days':
        return count;
      case 'hours':
        return 100 - (24 - count) / 24 * 100;
      case 'minutes':
        return 100 - (60 - count) / 60 * 100;
      case 'seconds':
        return 100 - (60 - count) / 60 * 100;
      default:
        return 0;
    }
  }
}
